<div class="card o-hidden">
    <div class="row">
        <div class="col-md-10 mx-auto">
            <h3 class="text-center text-uppercase">Aguarde</h3>
            <div class="mt-2 text-center">
                <p class="mx-auto" style="max-width: 400px">Você será direcionado a área do Superbid Exchange exclusiva
                    para revendas de máquinas.</p>

            </div>
            <div class="mt-2 mb-4 mx-auto">
                <app-loader [loading]="true" [small]="true" style="width: 100%; height: 100%;"></app-loader>
            </div>
        </div>
    </div>
</div>